// @ts-check

class TableSlider extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLDivElement | null} */
    this.tableContainer = this.querySelector('div[data-table-track-container]');

    /** @type {HTMLDivElement | null } */
    this.tableTrack = this.querySelector('div[data-table-track]');

    /** @type {HTMLTableElement | null } */
    this.table = this.querySelector('table');

    /** @type {HTMLButtonElement | null } */
    this.prevBtn = this.querySelector('button[data-nav-btn-prev]');

    /** @type {HTMLButtonElement | null } */
    this.nextBtn = this.querySelector('button[data-nav-btn-next]');

    /** @type {HTMLDivElement | null } */
    this.navBtnsWrapper = this.querySelector('div[data-nav-btns-wrapper]');

    this.setEventListeners();
    this.handleScroll();
  }

  setEventListeners() {
    if (!this.tableTrack || !this.prevBtn || !this.nextBtn) return;
    this.tableTrack.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

    this.prevBtn.addEventListener('click', this.handlePrevBtnClick.bind(this));
    this.nextBtn.addEventListener('click', this.handleNextBtnClick.bind(this));
  }

  handleScroll() {
    if (!this.table || !this.tableContainer || !this.tableTrack || !this.prevBtn || !this.nextBtn) return;

    if (this.table.offsetWidth <= this.tableTrack.offsetWidth) {
      this.tableContainer.classList.remove('has-scroll');
      this.navBtnsWrapper?.classList.add('hidden');
      return;
    }
    this.navBtnsWrapper?.classList.remove('hidden');

    const isTableFullyScrolled = this.tableTrack.scrollLeft + this.tableTrack.offsetWidth >= this.table.offsetWidth;

    this.prevBtn.disabled = this.tableTrack.scrollLeft <= 0;
    this.nextBtn.disabled = isTableFullyScrolled;

    this.tableContainer.classList.toggle('has-scroll', !isTableFullyScrolled);
  }

  handlePrevBtnClick() {
    if (!this.tableTrack) return;

    this.tableTrack.scrollTo({
      left: 0,
      behavior: 'smooth',
    });
  }
  handleNextBtnClick() {
    if (!this.tableTrack || !this.table) return;

    this.tableTrack.scrollTo({
      left: this.table.offsetWidth,
      behavior: 'smooth',
    });
  }
}

customElements.define('table-slider', TableSlider);
